import {
    Company,
    Name,
    Team,
    UserRole,
} from '@precon-tools-suite-by-shared/precon-graphql-types';
import mockInvitationsArray from './invitationMockData.json';
import mockLicensesArray from './licenseMockData.json';
import { NamedNode } from '@precon-tools-suite-by-shared/shared-names-ui';

// ------------------------------------------------------------------------------------------------------------------ //
//  INTERFACES                                                                                                        //
// ------------------------------------------------------------------------------------------------------------------ //

export interface Invitation {
    id: number;
    uuid: string;
    email: string | undefined;
    role: UserRole | undefined;
    status: 'OPEN' | 'EXPIRED' | 'ACCEPTED' | 'RESENT';
    invitedBy: string | undefined;
    createdAt: Date;
}

export interface License {
    id: number;
    team: Team;
    licenseType: 'Informed!' | 'Explained!' | 'Guided!' | undefined;
    isActive: boolean;
    updatedAt: Date | undefined | null;
    startedAt: Date;
    expiresAt: Date;
    duration: number;
}

// ------------------------------------------------------------------------------------------------------------------ //
//  FUNCTIONS                                                                                                         //
// ------------------------------------------------------------------------------------------------------------------ //

function calculateLicenseDuration(startDate: Date, endDate: Date): number {
    return Math.round(
        (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );
}

function getRandomDate(start: Date, end: Date) {
    return new Date(
        start.getTime() + Math.random() * (end.getTime() - start.getTime())
    );
}

function convArr(arr: any[]) {
    const startDate = new Date(2023, 5, 1);
    const endDate = new Date(2023, 11, 1);

    arr.forEach((x) => {
        if (x.status === 'ACCEPTED') {
            x.role = x.role === '' ? UserRole.Reader : x.role;
        }
        if (x.createdAt === undefined) {
            x.createdAt = getRandomDate(startDate, endDate);
        }
    });
    return arr;
}

function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

// ------------------------------------------------------------------------------------------------------------------ //
//  MOCK FETCH                                                                                                        //
// ------------------------------------------------------------------------------------------------------------------ //

const mockInvitations: Invitation[] = convArr(mockInvitationsArray);
const mockLicenses: License[] = convArr(mockLicensesArray);

export const mockFetchInvitations = (): Promise<Invitation[]> => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mockInvitations);
        }, 1000);
    });
};

export const mockFetchLicenses = (): Promise<License[]> => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mockLicenses);
        }, 1000);
    });
};

// ------------------------------------------------------------------------------------------------------------------ //
//  MOCK MUTATION                                                                                                     //
// ------------------------------------------------------------------------------------------------------------------ //

export const mockSendInvitation = (
    email: string | undefined | null
): Promise<Invitation> => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (email?.includes('@')) {
                const newInvitation: Invitation = {
                    id: mockInvitations.length + 1,
                    uuid: generateUUID(),
                    email,
                    role: UserRole.Reader,
                    status: 'OPEN',
                    invitedBy: 'ADMIN',
                    createdAt: new Date(),
                };
                console.log(newInvitation);
                mockInvitations.push(newInvitation);
                resolve(newInvitation);
            } else {
                reject(new Error('Invalid email address.'));
            }
        }, 1000);
    });
};

export const mockAddLicense = (
    teamName: Partial<NamedNode> | null | undefined,
    license: 'Informed!' | 'Explained!' | 'Guided!' | undefined
): Promise<License> => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            const exp = getRandomDate(new Date(), new Date(2024, 11, 1));
            if (teamName) {
                const addLicense: License = {
                    id: mockLicenses.length + 1,
                    team: {
                        name: teamName as Name,
                        company: teamName as Company,
                    } as Team,
                    licenseType: license,
                    isActive: true,
                    updatedAt: null,
                    startedAt: new Date(),
                    expiresAt: exp,
                    duration: calculateLicenseDuration(new Date(), exp),
                };
                console.log(addLicense);
                mockLicenses.push(addLicense);
                resolve(addLicense);
            } else {
                reject(new Error('Invalid team or license.'));
            }
        }, 1000);
    });
};

// export interface License {
//     id: number;
//     team: Team;
//     licenseType: 'Informed!' | 'Explained!' | 'Guided!';
//     isActive: boolean;
//     updatedAt: Date;
//     startedAt: Date;
//     expiresAt: Date;
//     duration: number;
// }
